import React from 'react';
import {IconButton} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import {InfoIcon} from "../../../../../helpers/Icons";

const styles = {
  info: {
    fontSize: '1rem !important',
    padding: '3px',
    margin: '0 0.25rem',
    '& svg': {
      fontSize: "inherit",
      color: "#1976d2",
    }
  }
};

function HelpInfoButton(props) {
  const {id="helpInfoButton", helpIndex, classes} = props;
  if(!helpIndex){
    return null;
  }
  return <IconButton
      id={id}
      className={classes.info}
      component={"a"}
      href={`#help_${helpIndex}.0.0`}
      onClick={e => e.stopPropagation()}
    >
      <InfoIcon fontSize={"small"} />
    </IconButton>;
}

export default withStyles(styles)(HelpInfoButton);
